//EXTERNAL
import React from "react";
//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { usePagination } from "../functions/pagination";
//TYPES
import { TableProps } from "../types";

/**
 * JA (01-08-23)
 * Table component displaying either creatives or advertiser information.
 * requestTableData is the state of slider component which determines what type of information is passed to the table.
 */
export function Table({ requestTableData, advertiserId, columns, data, loading, paginatedTotal, offset, limit, itemsCount, currentPageNumber, setOffset, updateSortOrder, sortOrder, updateParams }: TableProps) {
  const { handleOffsetHandler, handleSequentialPage, handlePageNumber, handleSequentialPageNumber } = usePagination({ limit, setOffset });
  const [adsColumns, brandsColumns] = columns;
  const [dataItemsCount, advertiserNamesCount] = itemsCount;
  const [creatives, advertisersData] = data;

  const isAdsTable = requestTableData === "Ads" || advertiserId;
  const isAdsLastUpdatedColumn = (id: string) => id === "last-updated";

  const tableCount = isAdsTable ? dataItemsCount : advertiserNamesCount;
  const tableColumn = isAdsTable ? adsColumns : brandsColumns;
  const tableData = isAdsTable ? creatives : advertisersData;
  /**
   * JA (01-08-23)
   * invertedObject: Creates a new object with inverted boolean values for each key in the sort object.
   * This will get passed as the new sorting state when a user clicks on the `Last Updated` header.
   */
  const invertedObject = Object.fromEntries(Object.entries(sortOrder).map(([key, value]) => [key, !value] as [string, boolean])) as { asc: boolean; desc: boolean };
  /**
   * sortOption: Finds the first sorting preference ('asc' or 'desc') that is set to true in the sortOrder object.
   */
  const sortOption = Object.keys(sortOrder).find((key) => sortOrder[key as keyof typeof sortOrder]);
  /**
   * JA (01-08-23)
   * For the `Last Updated` header, pass a function to inversely update the sort object.
   * This object is then destructured to find the truthy key which is used as the sort url param value.
   */
  const sortingOrder = (id: string) => {
    if (isAdsLastUpdatedColumn(id)) {
      updateSortOrder(invertedObject);
      updateParams(Object.keys(invertedObject).find((key: string) => invertedObject[key as keyof typeof invertedObject])!, "sort");
    }
  };
  /**
   * JA (01-08-23)
   * Pass a function to declare which column has sorting enabled.
   */
  const sortingEnabledHeader = (id: string) => isAdsLastUpdatedColumn(id) && <ComponentLibrary.PCIconPicker icon={`chevron-${sortOption === "asc" ? "up" : "down"}`} size="xs" />;

  return (
    <>
      <ComponentLibrary.PCSpacer type={"margin"} position={"bottom"} size={4} />
      <ComponentLibrary.PCTable columns={tableColumn} data={tableData} loading={loading} totalNumberOfPages={paginatedTotal} offset={offset} limit={limit} dataItemsCount={tableCount} currentPageNumber={currentPageNumber} offsetHandler={handleOffsetHandler} handlePageNumber={handlePageNumber} handleSequentialPageNumber={handleSequentialPageNumber} sequentialPageHandler={handleSequentialPage} sortingEnabled={true} updateSortOrder={sortingOrder} sortingEnabledHeader={sortingEnabledHeader} />
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
    </>
  );
}
